module.exports = __webpack_public_path__ + "img/img8.21f651b7.svg";